import { render, staticRenderFns } from "./custom-logo.vue?vue&type=template&id=8dbe7a2a&scoped=true"
import script from "./custom-logo.vue?vue&type=script&lang=js"
export * from "./custom-logo.vue?vue&type=script&lang=js"
import style0 from "./custom-logo.vue?vue&type=style&index=0&id=8dbe7a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbe7a2a",
  null
  
)

export default component.exports